// --- Images: Index ---
import BgAdvancingSustainableLifestyles from "../../../assets/images/content/pillar-1/index/bg-header-2.webp";
import Pillar1Repair from "../../../assets/images/content/pillar-1/index/dishwasher.webp";

// --- Images: Production ---
import AverageMaterialCompositionOfHomeAppliances01 from "../../../assets/images/content/pillar-1/production/average-material-composition-of-home-appliances.jpg";
import MaterialUseDuringProductionDesktop from "../../../assets/images/content/pillar-1/production/material-use-during-the-production-process-desktop.svg";
import MaterialUseDuringProductionMobile from "../../../assets/images/content/pillar-1/production/material-use-during-the-production-process-mobile.svg";
import QuantitiesDesktop from "../../../assets/images/content/pillar-1/production/quantities-of-materials-used-desktop.svg";
import QuantitiesMobile from "../../../assets/images/content/pillar-1/production/quantities-of-materials-used-mobile.svg";

// --- Images: Use & Consumption ---
import AverageAnnualAdditionalSavingsImg from "../../../assets/images/content/pillar-1/use-and-consumption/average-annual-additional-savings.jpg";
import EnergyConsumptionSavingsArea from "../../../assets/images/content/pillar-1/use-and-consumption/energy-consumption-savings-area.jpg";
import EnergyConsumptionSavingsComparison from "../../../assets/images/content/pillar-1/use-and-consumption/energy-consumption-savings-comparison.jpg";
import EvolutionEnergyBarchartDesktop from "../../../assets/images/content/pillar-1/use-and-consumption/evolution-of-energy-consumption-barchart-desktop.svg";
import EvolutionEnergyBarchartMobile from "../../../assets/images/content/pillar-1/use-and-consumption/evolution-of-energy-consumption-barchart-mobile.svg";
import EnergyPricesEUDesktop from "../../../assets/images/content/pillar-1/use-and-consumption/energy-consumption-and-prices-desktop.svg";
import EnergyPricesEUMobile from "../../../assets/images/content/pillar-1/use-and-consumption/energy-consumption-and-prices-mobile.svg";
import IncreaseInEnergyEfficientProducts from "../../../assets/images/content/pillar-1/use-and-consumption/increase-in-energy-efficient-products.svg";
import RepairDesktop from "../../../assets/images/content/pillar-1/use-and-consumption/repair-desktop.svg";
import RepairMobile from "../../../assets/images/content/pillar-1/use-and-consumption/repair-mobile.svg";

// --- Images: Recycling ---
import MaterialsRecoveredFromWasteImg from "../../../assets/images/content/pillar-1/recycling/materials-recovered-from-waste.jpg";
import RoutesRecycledPlasticDesktop from "../../../assets/images/content/pillar-1/recycling/routes-of-recycled-plastics-desktop.svg";
import RoutesRecycledPlasticMobile from "../../../assets/images/content/pillar-1/recycling/routes-of-recycled-plastics-mobile.svg";
import WeeeCollectedAndOtherNonCompliantFlowsDesktop from "../../../assets/images/content/pillar-1/recycling/weee-collected-and-other-non-compliant-flows-desktop.svg";
import WeeeCollectedAndOtherNonCompliantFlowsMobile from "../../../assets/images/content/pillar-1/recycling/weee-collected-and-other-non-compliant-flows-mobile.svg";

// --- Vectors ---
import HoardingOfWeeeVisual from "../../../assets/vectors/content/pillar-1/hoarding-of-weee/Hoarding of WEEE.svg";

// --- KPI icons ---
import { ReactComponent as IconZap } from "../../../assets/vectors/icons/kpi/zap.svg";
import { ReactComponent as IconLayers } from "../../../assets/vectors/icons/kpi/layers.svg";
import { ReactComponent as IconWeight } from "../../../assets/vectors/icons/kpi/weight.svg";
import { ReactComponent as IconAward } from "../../../assets/vectors/icons/kpi/award.svg";
import { ReactComponent as IconHouse } from "../../../assets/vectors/icons/kpi/house.svg";
import { ReactComponent as IconWrench } from "../../../assets/vectors/icons/kpi/wrench.svg";
import { ReactComponent as IconTrash } from "../../../assets/vectors/icons/kpi/trash.svg";
import { ReactComponent as IconTruck } from "../../../assets/vectors/icons/kpi/truck.svg";
import { ReactComponent as IconRecycle } from "../../../assets/vectors/icons/kpi/recycle.svg";

// --- Components ---
import { AverageEnergyConsumptionDishwashers } from "../../../components/CustomPageBlocks/pillar1/AverageEnergyConsumption/AverageEnergyConsumptionDishwashers";
import { AverageEnergyConsumptionWashingMachines } from "../../../components/CustomPageBlocks/pillar1/AverageEnergyConsumption/AverageEnergyConsumptionWashingMachines";
import { AverageWaterConsumptionDishwashers } from "../../../components/CustomPageBlocks/pillar1/AverageWaterConsumption/AverageWaterConsumptionDishwashers";
import { AverageWaterConsumptionWashingMachines } from "../../../components/CustomPageBlocks/pillar1/AverageWaterConsumption/AverageWaterConsumptionWashingMachines";
import { AvgMaterialCompositionLargeHomeAppliances } from "../../../components/CustomPageBlocks/pillar1/AvgMaterialCompositionLargeHomeAppliances/AvgMaterialCompositionLargeHomeAppliances";
import { AvgMaterialCompositionSmallHomeAppliances } from "../../../components/CustomPageBlocks/pillar1/AvgMaterialCompositionSmallHomeAppliances/AvgMaterialCompositionSmallHomeAppliances";
import { CollectionOfWEEEByEUMemberStates } from "../../../components/CustomPageBlocks/pillar1/CollectionOfWEEEByEUMemberStates/CollectionOfWEEEByEUMemberStates";
import { EvolutionOfEnergyConsumptionAndEnergyPrices } from "../../../components/CustomPageBlocks/pillar1/EvolutionOfEnergyConsumptionAndEnergyPrices/EvolutionOfEnergyConsumptionAndEnergyPrices";
import { WeeeFlowInTheHomeApplianceSector } from "../../../components/CustomPageBlocks/pillar1/WeeeFlowInTheHomeApplianceSector/WeeeFlowInTheHomeApplianceSector";

// --- Data ---
import AvgMaterialCompositionLargeHomeAppliancesData from "../../../assets/data/content/pillar-1/avg-material-composition-large-home-appliances/data.json";
import AvgMaterialCompositionSmallHomeAppliancesData from "../../../assets/data/content/pillar-1/avg-material-composition-small-home-appliances/data.json";
import AverageEnergyConsumptionDishwashersData from "../../../assets/data/content/pillar-1/average-energy-consumption-dishwashers/data.json";
import AverageEnergyConsumptionWashingMachinesData from "../../../assets/data/content/pillar-1/average-energy-consumption-washing-machines/data.json";
import AverageWaterConsumptionDishwashersData from "../../../assets/data/content/pillar-1/average-water-consumption-dishwashers/data.json";
import AverageWaterConsumptionWashingMachinesData from "../../../assets/data/content/pillar-1/average-water-consumption-washing-machines/data.json";
import CollectionOfWEEEByEUMemberStatesData from "../../../assets/data/content/pillar-1/collection-of-weee-by-eu-member-states/data.json";
import EvolutionOfEnergyConsumptionAndEnergyPricesLineChartData from "../../../assets/data/content/pillar-1/evolution-of-energy-consumption-and-energy-prices/line-chart-data.json";
import WeeeFlowInTheHomeApplianceSectorLineChartData from "../../../assets/data/content/pillar-1/weee-flow-in-the-home-appliance-sector/line-chart-data.json";
import { repairImages } from "../../../assets/data/content/pillar-1/repair-of-home-appliances/data";

// --- Marginalia ---
import { createChartMarginalia } from "../marginalia/createChartMarginalia";
import { productionPageMarginalia } from "../marginalia/pillar1Production";
import { useAndConsumptionPageMarginalia } from "../marginalia/pillar1UseAndConsumption";
import { recyclingPageMarginalia } from "../marginalia/pillar1Recycling";

// --- Types ---
import { PageContent } from "./types";

export const pillar1Content: Record<string, PageContent> = {
	"/pillar/1": {
		heroImage: BgAdvancingSustainableLifestyles,
		heroIntro: "The transition to a highly circular economy in Europe is anchored by the home appliance sector's ability to weave resource efficiency into every stage of a product's lifecycle.",
		blocks: [
			{
				id: "pillar1-intro-text",
				type: "text",
				data: {
					text: [
						"True sustainability is no longer viewed merely as an eco-friendly feature designed for the consumer, but as a comprehensive structural framework that begins on the factory floor and extends long past a product's active use life.",
						"As the home appliance sector sits directly at the intersection of Europe’s competitive, economic, and environmental objectives, the industry is actively spearheading changes that address raw material use and carbon footprints simultaneously. By establishing forward-thinking design principles and robust efficiency benchmarks, manufacturers are demonstrating that long-term consumer utility can be successfully decoupled from environmental degradation. This chapter tracks industrial progression across three core strategic dimensions: the systemic reduction of manufacturing footprints, the optimisation of active product lifespans and utility demands, and the development of high-yield collection and secondary raw material markets.",
					],
				},
			},
			{
				id: "pillar1-repair-text-image",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: Pillar1Repair,
					imageAlt: "Repair of home appliances",
					imageSize: "normal",
					text: [
						"The initial phase of this lifecycle focuses on the production footprint. Manufacturing facilities have undergone deep operational restructurings to minimise industrial inputs and localise factory waste. Modern appliances rely on a diverse matrix of materials, ranging from structural heavy metals to flexible polymers, carefully selected to maximise product durability and facilitate seamless recycling loops.","Once these appliances enter European households, the focal point of sustainability transitions into daily consumption. The active operational phase represents the single largest share of a product's lifelong resource footprint, making continuous efficiency improvements a primary driver of domestic utility relief. Decades of engineering breakthroughs have radically transformed energy and water footprints, helping consumers defend against volatile macroeconomic conditions and rising utility inflation across individual EU member states.",
					],
				},
			},
			{
				id: "pillar1-final",
				type: "text",
				data: {
					text: "Finally, the pillar addresses closing the loop through a robust repair and electronic waste reclamation infrastructure. Prioritising durability means maintaining an extensive, high-performance maintenance network to keep products functional well beyond their design baselines. When a product ultimately reaches the true end of its operational life, advanced collection systems ensure that discarded materials are effectively processed, keeping them circulating within the economy."
				}
			}
		],
	},
	"/pillar/1/production": {
		pageMarginalia: productionPageMarginalia,
		blocks: [
			{
				id: "production-intro",
				type: "opening-text",
				data: {
					text: "Before an appliance enters a consumer's home, its environmental trajectory is heavily determined by the resource intensity of its manufacturing process. To achieve true decoupling, European appliance manufacturers have fundamentally restructured factory operations to minimise industrial inputs and localise waste. This industrial shift is directly reflected in the significant reductions achieved across energy, water, and waste outputs, demonstrating that process optimisation is just as critical to the sector's climate goals as product design itself.",
				},
			},
			{
				id: "production-kpis",
				type: "kpi-cards",
				data: {
					items: [
						{
							value: "-50%",
							unit: "",
							comparison: "",
							description: "Energy used during production",
							icon: IconZap,
						},
						{
							value: "20+",
							unit: "",
							comparison: "",
							description: "Different types of materials used in manufacturing",
							icon: IconLayers,
						},
						{
							value: "36%",
							unit: "",
							comparison: "",
							description: "Appliance weight made of steel",
							icon: IconWeight,
						},
					],
				},
			},
			{
				id: "production-text-1",
				type: "text",
				data: {
					text: "The systemic optimisation of manufacturing footprints represents the first critical phase of this lifecycle progression. Recent industrial data reveals that <strong>targeted process enhancements</strong> have enabled European appliance manufacturers to contract waste generation by 18% and decrease water consumption by 14%. Most notably, <strong>production facilities have successfully halved their total energy requirements</strong>, marking a strict 50% drop in energy consumption during manufacturing. ",
				},
			},
			{
				type: "responsive-image",
				id: "production-material-use-during-production",
				chartLabel: "Chart 1.1",
				data: {
					desktopImageUrl: MaterialUseDuringProductionDesktop,
					mobileImageUrl: MaterialUseDuringProductionMobile,
					imageAlt: "Small infographic showing three types of reduction in the production process for home appliances. On the left, an image of underwater plastic, with text reading -18% reduction in waste generation during production. In the middle, an image of a water droplet on a water surface, with text reading -14% reduction in water consumption during production. On the right, an image of light streaks in an evening sky, with text reading -50% of reduction in energy consumption during production.",
					title: "Material use during the production process",
					breakpoint: "sm",
					desktopClassName: "w-full max-w-6xl",
					mobileClassName: "w-full max-w-md self-start",
				},
				marginalia: createChartMarginalia("dss+", "production-material-use-during-production", "applia-home-appliance-monitor-2025_material-use-during-the-production-process.png", { label: "CHART 1.1" }),
			},
			{
				id: "production-text-image",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: AverageMaterialCompositionOfHomeAppliances01,
					imageAlt: "Average material composition of home appliances",
					imageSize: "normal",
					text: [
						"Engineering modern appliances relies on a diverse material architecture utilising <strong>over 20 distinct types of materials</strong>, which accounts for an estimated <strong>annual production material footprint of 5.31 million tonnes</strong> across the sector. Heavy structural metals dictate the bulk of this volume, led by steel at 36%, stainless steel at 10%, concrete at 8%, and glass at 7%. While rigid metals and concrete provide the massive baseline needed for large home appliances, lighter polymers and plastics comprise 23% of the total sector material share and play a more pronounced role in the flexible design of small appliances.",
					],
				},
			},
			{
				type: "responsive-image",
				id: "production-quantities-of-individual-materials",
				chartLabel: "Chart 1.2",
				data: {
					desktopImageUrl: QuantitiesDesktop,
					mobileImageUrl: QuantitiesMobile,
					imageAlt: "Donut chart showing the quantities of individual materials used in home appliances. Aluminum covers 3%, Concrete 8%, Copper 1%, Glass 7%, Plastics 23%, Steel 36%, Stainless steel 10%, Electronics 2%, and Other 9%. The total amount used is 5.31 megatons.",
					title: "Quantities of individual materials used in home appliances",
					breakpoint: "sm",
					desktopClassName: "w-full max-w-2xl",
					mobileClassName: "w-full max-w-md self-start",
				},
				marginalia: createChartMarginalia("dss+", "production-quantities-of-individual-materials", "applia-home-appliance-monitor-2025_quantities-of-individual-materials-used-in-home-appliances.png", { label: "CHART 1.2" }),
			},
			{
				type: "custom",
				id: "production-avg-material-composition-large",
				chartLabel: "Chart 1.3a",
				data: {
					component: AvgMaterialCompositionLargeHomeAppliances,
					props: {
						data: AvgMaterialCompositionLargeHomeAppliancesData,
					},
					title: "Average material composition of large home appliances",
				},
				marginalia: createChartMarginalia("dss+", "production-avg-material-composition-large","applia-home-appliance-monitor-2025_average-material-composition-of-large-home-appliances.png", { label: "CHART 1.3a" }),
			},
			{
				type: "custom",
				id: "production-avg-material-composition-small",
				className: "mt-16 md:mt-20",
				chartLabel: "Chart 1.3b",
				data: {
					component: AvgMaterialCompositionSmallHomeAppliances,
					props: {
						data: AvgMaterialCompositionSmallHomeAppliancesData,
					},
					title: "Average material composition of small home appliances",
				},
				marginalia: createChartMarginalia("dss+", "production-avg-material-composition-small", "applia-home-appliance-monitor-2025_average-material-composition-of-small-home-appliances.png", { label: "CHART 1.3b" }),
			},
		],
	},
	"/pillar/1/use-and-consumption": {
		pageMarginalia: useAndConsumptionPageMarginalia,
		blocks: [
			{
				id: "use-and-consumption-intro",
				type: "opening-text",
				data: {
					text: "While efficiency begins on the production line, the true test of an appliance's environmental impact occurs once it enters active service within European households. Because the operational phase historically accounts for the largest share of a product's lifelong energy and water footprint, <strong>continuous consumer-side innovation</strong> remains a primary objective for the sector. The subsequent data tracking maps decades of rigorous <strong>engineering breakthroughs</strong>, illustrating how the rapid market shift toward top-tier energy labels has translated directly into massive, cumulative <strong>utility savings for European consumers</strong>.",
				},
			},
			{
				id: "use-and-consumption-kpis",
				type: "kpi-cards",
				data: {
					items: [
						{
							value: "31%",
							unit: "",
							comparison: "",
							description: "Share of premium efficient appliances",
							icon: IconAward,
						},
						{
							value: "98.8",
							unit: "Mtoe",
							comparison: "",
							description: "Cumulative household energy savings",
							icon: IconHouse,
						},
						{
							value: "95%",
							unit: "",
							comparison: "",
							description: "Consumer repair requests completed",
							icon: IconWrench,
						},
					],
				},
			},
			{
				id: "use-and-consumption-energy-efficient-products",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: IncreaseInEnergyEfficientProducts,
					imageAlt: "Increase in energy efficient products",
					imageSize: "small",
					text: [
						"The tangible impact of the sector’s innovation curve is most immediately visible in retail market trends. When tracking the efficiency composition of new product rollouts, a dramatic structural shift becomes apparent. In 2020, <strong>top-tier A- and B-labeled energy products</strong> represented just a minor fraction (7%) of all home appliances launched in Europe. Over the subsequent five years, targeted research and regulatory adaptation drove a 4.4-fold increase, pushing that premium market share up to an impressive 31% by 2025.","This rapid commercialisation of highly efficient technology has fundamentally altered consumer utility dynamics across the continent. By looking closely at long-term internal metrics for core residential tasks, the real-world benefits of this label migration become distinct.",
					],
				},
				marginalia: createChartMarginalia("Ecodesign Impact Accounting Overview Report 2025, The Global E-waste Monitor 2024", "use-and-consumption-energy-efficient-products", "applia-home-appliance-monitor-2025_increase-in-energy-efficient-products.png", { label: "CHART 1.4" }),
			},
			{
				id: "use-and-consumption-text-0",
				type: "text",
				data: {
					text: "The historical consumption data for washing machines and dishwashers underscores a steady, <strong>multi-decade engineering victory over resource intensity</strong>. In the late 1990s, an average laundry cycle demanded more than 65 liters of water. Through systemic design changes, average <strong>water requirements steadily contracted</strong>, stabilising at approximately 46.0 liters per cycle. This optimisation was achieved while simultaneously <strong>lowering electrical demands</strong>, dropping washing machine energy footprints to a highly efficient 0.6 kWh per cycle.",
				},
			},
			{
				id: "use-and-consumption-water-dual-chart",
				type: "dual-chart",
				chartLabel: "Chart 1.5a",
				data: {
					component1: AverageWaterConsumptionWashingMachines,
					props1: {
						data: AverageWaterConsumptionWashingMachinesData,
					},
					component2: AverageEnergyConsumptionWashingMachines,
					props2: {
						data: AverageEnergyConsumptionWashingMachinesData,
					},
				},
				marginalia: createChartMarginalia("APPLiA members data", "use-and-consumption-water-dual-chart", "applia-home-appliance-monitor-2025_water-and-energy-consumption-of-washing-machines.png", { label: "CHART 1.5a" }),
			},
			{
				id: "use-and-consumption-text-1",
				type: "text",
				data: {
					text: "Parallel breakthroughs transformed kitchen hygiene appliances. <strong>Dishwashers systematically halved their historical water requirements</strong>, dropping from an average of 20 liters per cycle down to 9.5 liters. This water-saving profile operates alongside a lean, deeply managed electrical requirement of 1.1 kWh per cycle. When aggregated, these individual appliance efficiencies fundamentally reconfigure macro-level consumption across the broader European economy.",
				},
			},
			{
				id: "use-and-consumption-energy-dual-chart",
				type: "dual-chart",
				chartLabel: "Chart 1.5b",
				data: {
					component1: AverageWaterConsumptionDishwashers,
					props1: {
						data: AverageWaterConsumptionDishwashersData,
					},
					component2: AverageEnergyConsumptionDishwashers,
					props2: {
						data: AverageEnergyConsumptionDishwashersData,
					},
				},
				marginalia: createChartMarginalia("APPLiA members data", "use-and-consumption-energy-dual-chart", "applia-home-appliance-monitor-2025_water-and-energy-consumption-of-dishwashers.png", { label: "CHART 1.5b" }),
			},
			{
				id: "use-and-consumption-text-1b",
				type: "text",
				data: {
					text: "The true value of these household efficiency milestones is highlighted when indexed against broader macroeconomic factors. Over the past decade, European consumers have faced an increasingly volatile energy market. While private consumption spending rose to an index value of 113 by 2023, average energy prices skyrocketed to an index peak of 134. Under normal conditions, such a pricing spike would severely stress domestic finances. However, because of the widespread adoption of efficient appliances, total <strong>household energy consumption decoupled from rising costs</strong>, falling down to an index value of 92.",
				},
			},
			{
				type: "custom",
				id: "use-and-consumption-evolution-energy-visual",
				chartLabel: "Chart 1.6a",
				data: {
					component: EvolutionOfEnergyConsumptionAndEnergyPrices,
					props: {
						lineChartData: EvolutionOfEnergyConsumptionAndEnergyPricesLineChartData,
					},
				},
				marginalia: createChartMarginalia("B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, <a href='https://www.odyssee-mure.eu/events/webinar' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE webinar</a>, November 2024.", "use-and-consumption-evolution-energy-visual", "applia-home-appliance-monitor-2025_evolution-of-energy-consumption-and-energy-prices.png", { label: "CHART 1.6a" }),
			},
			{
				id: "use-and-consumption-text-2",
				type: "text",
				data: {
					text: "During the 2010 to 2014 era, early efficiency gains kept household energy growth negative at -1.2%, even as average energy prices rose by 4.3%. This was followed by the 2014 to 2020 era, a period of minor cost deflation of -1.1% where household consumption stabilised with a slight increment of 0.9%. Finally, during the 2020 to 2023 era, when energy prices experienced a massive 6.4% surge, household energy demands dropped by a significant 2.8%, proving that residential technology acted as a primary buffer against inflation. This defensive shielding against energy inflation is further validated when tracking consumer behavior on a country-by-country basis across the EU.",
				},
			},
			{
				type: "responsive-image",
				id: "use-and-consumption-evolution-energy-barchart",
				chartLabel: "Chart 1.6b",
				data: {
					desktopImageUrl: EvolutionEnergyBarchartDesktop,
					mobileImageUrl: EvolutionEnergyBarchartMobile,
					imageAlt: "Evolution of energy consumption and energy prices",
					containerClassName: "flex flex-col mt-8",
					title: "Evolution of energy consumption and energy prices in the EU",
				},
				marginalia: createChartMarginalia("B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, <a href='https://www.odyssee-mure.eu/events/webinar' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE webinar</a>, November 2024.", "use-and-consumption-evolution-energy-barchart", "applia-home-appliance-monitor-2025_evolution-of-energy-consumption-and-energy-prices-in-the-eu.png", { label: "CHART 1.6b" })
			},
			{
				id: "use-and-consumption-text-2b",
				type: "text",
				data: {
					text: "The direct correlation between rising operational costs and consumer resource conservation is clearly visible across individual EU member states. In regions that experienced the steepest inflation spikes between 2019 and 2023, domestic conservation responded in direct proportion. For instance, the Netherlands saw average energy costs climb by 12.8%, triggering a 2.3% drop in domestic energy use. Similar defensive conservation patterns emerged in Austria, which experienced a 9.3% price increase against a 1.6% consumption drop, and France, which marked a 3.4% price increase against a 2.2% consumption drop. This regional mosaic confirms that <strong>highly efficient appliances have become vital tools for national economic resilience.</strong>",
				},
			},
			{
				type: "responsive-image",
				id: "use-and-consumption-energy-prices-eu",
				chartLabel: "Chart 1.7",
				data: {
					desktopImageUrl: EnergyPricesEUDesktop,
					mobileImageUrl: EnergyPricesEUMobile,
					imageAlt: "Energy consumption and energy prices in the EU",
					containerClassName: "flex flex-col mt-8",
					desktopClassName: "max-w-4xl",
					title: " "
				},
				marginalia: createChartMarginalia("B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, <a href='https://www.odyssee-mure.eu/events/webinar' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE webinar</a>, November 2024.", "use-and-consumption-energy-prices-eu", "applia-home-appliance-monitor-2025_change-in-energy-prices-and-energy-consumption.png", { label: "CHART 1.7" })
			},
			{
				id: "use-and-consumption-text-3",
				type: "text",
				data: {
					text: "When comparing energy consumption and historical savings across all major economic sectors, the domestic housing block emerges as the primary driver of European conservation. As of 2024, transport remains the largest single consumer of energy at 34.4%, followed by households at 26.3%, industry at 25.7%, and services at 13.6%.",
				},
			},
			{
				id: "use-and-consumption-savings-comparison",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: EnergyConsumptionSavingsComparison,
					imageAlt: "Energy consumption savings comparison",
					imageSize: "normal",
					text: [
						"Yet, when evaluating cumulative energy savings achieved between 2000 and 2024, the proportions tell a completely different story. <strong>Households generated a massive 39.6% of all European energy savings</strong>, outperforming industry at 30.3%, transport at 18.0%, and services at 12.1%. In absolute terms, this residential triumph represents a cumulative 98.9 Mtoe in avoided energy use.",
					],
				},
				marginalia: createChartMarginalia("Lapillonne, B., & Sudries, L. (2020, July). Overall trends in energy efficiency in the EU. ODYSSEE-MURE. <a href='https://www.odyssee-mure.eu/publications/policy-brief/overall-energy-efficiency-trends.html' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE policy brief</a>", "use-and-consumption-savings-comparison", "applia-home-appliance-monitor-2025_energy-consumption-and-savings.png", { label: "CHART 1.8" })
			},
			{
				type: "responsive-image",
				id: "use-and-consumption-savings-area",
				chartLabel: "Chart 1.9",
				data: {
					desktopImageUrl: EnergyConsumptionSavingsArea,
					mobileImageUrl: EnergyConsumptionSavingsArea,
					imageAlt: "Energy consumption savings area chart",
					containerClassName: "flex flex-col mt-8",
					desktopClassName: "max-w-4xl",
					title: "Accumulated energy savings from efficiency measures, by sector"
				},
				marginalia: createChartMarginalia("Lapillonne, B., & Sudries, L. (2020, July). Overall trends in energy efficiency in the EU. ODYSSEE-MURE. <a href='https://www.odyssee-mure.eu/publications/policy-brief/overall-energy-efficiency-trends.html' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE policy brief</a>", "use-and-consumption-savings-area", "applia-home-appliance-monitor-2025_accumulated-energy-savings-from-efficiency-measures.png", { label: "CHART 1.9" })
			},
			{
				id: "use-and-consumption-annual-savings-header",
				type: "header",
				chartLabel: "Chart 1.10",
				data: {
					type: "h3",
					text: "Average annual additional savings for households",
					showChartLabel: true
				},
			},
			{
				id: "use-and-consumption-annual-savings",
				type: "text-image",
				data: {
					type: "image-left",
					imageUrl: AverageAnnualAdditionalSavingsImg,
					imageAlt: "Average annual additional savings",
					imageSize: "normal",
					text: [
						"An analysis of average annual additional savings further underscores this domestic acceleration. Between 2000 and 2014, the region secured an average of 4.76 Mtoe per year in additional household savings, heavily driven by space heating optimisations at 3.63 Mtoe per year. Progress slowed during the 2015 to 2019 temporary plateau to 1.46 Mtoe per year. However, during the 2020 to 2023 era, the pace surged to a record 5.02 Mtoe per year in additional savings, with advanced heating solutions yielding 4.20 Mtoe per year and other appliances contributing 0.81 Mtoe per year.",
					],
				},
				marginalia: createChartMarginalia("B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, <a href='https://www.odyssee-mure.eu/events/webinar' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>Odyssee MURE webinar</a>, November 2024.", "use-and-consumption-annual-savings", "applia-home-appliance-monitor-2025_average-annual-additional-savings-for-households.png", { label: "CHART 1.10" })
			},
			{
				id: "use-and-consumption-text-final",
				type: "text",
				data: {
					text: "A fully realised circular lifecycle depends on <strong>accessible, professional repair infrastructure</strong> to keep appliances functional well beyond their design baselines. Out of the 276.5 million appliance units placed on the European market in 2023, an extensive after-sales network generated an <strong>industry turnover of €1.6 billion for repair and service</strong>. This dedicated framework, comprising over 24,250 localised business partners, successfully <strong>resolved 95% of all consumer repair requests</strong>.",
				},
			},
			{
				id: "repair-of-home-appliances-header",
				type: "header",
				chartLabel: "Chart 1.11",
				data: {
					type: "h3",
					text: "Repair of home appliances",
					showChartLabel: true
				},
			},
			{
				type: "image-grid",
				id: "use-and-consumption-repair-images",
				data: {
					cols: 4,
					responsiveCols: {
						xs: 2,
						md: 4,
						lg: 4,
					},
					items: repairImages,
				},
				marginalia: createChartMarginalia("dss+ calculations based on APPLiA members data", "repair-of-home-appliances-header", "applia-home-appliance-monitor-2025_repair-of-home-appliances.png", { label: "CHART 1.11" })
			},
			{
				type: "responsive-image",
				id: "use-and-consumption-repair",
				data: {
					desktopImageUrl: RepairDesktop,
					mobileImageUrl: RepairMobile,
					containerClassName: "flex flex-col items-center justify-center border-dotted border-t-2 border-gray-500",
					desktopClassName: "w-full mt-8",
					mobileClassName: "max-w-lg mt-8",
				},
			},
			{
				id: "use-and-consumption-text-veryfinal",
				type: "text",
				data: {
					text: ["The underlying cost structure of these maintenance operations reveals a distinct operational divide based on product category. For large home and comfort appliances, physical complexity and on-site demands make labor the primary financial component, consuming 63% of large appliances and 60% of home comfort repair costs, while transport expenses account for an additional 12% to 15%. For small home appliances, the economic weight shifts strictly to materials, where raw spare parts comprise the largest individual cost fraction at 42% and labor requires a smaller 38% share.", "This higher percentage share reflects the lower overall baseline price of small appliances and lower labour requirements—rather than higher component pricing—as fixed manufacturing and distribution costs form a larger relative portion of the repair.", "By maintaining this <strong>high repair success rate</strong>, the industry prevents premature product disposal. Yet, when an appliance ultimately reaches the true end of its operational life, the strategy transitions from active preservation to advanced material reclamation."],
				},
			},
		],
	},
	"/pillar/1/recycling": {
		pageMarginalia: recyclingPageMarginalia,
		blocks: [
			{
				id: "recycling-intro",
				type: "opening-text",
				data: {
					text: "The final and crucial stage of the circular lifecycle moves the emphasis from preserving products to recovering and reusing their materials. Building a low-carbon economy requires a robust recovery infrastructure capable of capturing end-of-life appliances and converting them into high-purity secondary raw materials, supported by industry platforms like the <a target=\"_blank\" rel=\"noreferrer\" class=\"text-primary underline\" href=\"https://i4r-platform.eu/\">I4R Platform</a>. The upcoming charts expose both the challenges and achievements of this regional network, tracking the scale of domestic electronic waste, the structural obstacle of consumer hoarding, and the distinct recycling pathways that successfully channel reclaimed polymers and metals back into the economy.",
				},
			},
			{
				id: "recycling-kpis",
				type: "kpi-cards",
				data: {
					items: [
						{
							value: "90",
							unit: "Mt",
							comparison: "",
							description: "Total mass of electronic waste in homes",
							icon: IconTrash,
						},
						{
							value: "4,9",
							unit: "Mt",
							comparison: "",
							description: "Electronic waste collected by the sector",
							icon: IconTruck,
						},
						{
							value: "3,7",
							unit: "Mt",
							comparison: "",
							description: "Raw materials successfully recovered",
							icon: IconRecycle,
						},
					],
				},
			},
			{
				type: "text",
				id: "recycling-harding-weee-intro",
				data: {
					text: [
						"Across Europe, an estimated <strong>90 million tonnes of Waste Electrical and Electronic Equipment (WEEE) are currently stored in homes</strong>. This “hoarding” of electrical appliances is particularly evident for food preparation devices (1,671 million units) and personal care items (802 million units).","Addressing this challenge requires looking beyond households and <strong>recognising the role of all actors across the value chain</strong>. Circularity depends on clearly defined and enforceable responsibilities for producers, retailers, online marketplaces, waste operators, and public authorities alike. Where these responsibilities are not fully aligned, collection systems tend to operate in a fragmented way.",
					],
				},
			},
			{
				type: "responsive-image",
				id: "recycling-hoarding-weee",
				chartLabel: "Chart 1.12",
				data: {
					desktopImageUrl: HoardingOfWeeeVisual,
					mobileImageUrl: HoardingOfWeeeVisual,
					desktopClassName: "w-full max-w-2xl",
					mobileClassName: "max-w-lg",
					title: "Hoarding of WEEE"
				},
				marginalia: createChartMarginalia("WEEE forum data and dss+", "recycling-hoarding-weee", "applia-home-appliance-monitor-2025_hoarding-of-weee.png", { label: "CHART 1.12" })
			},
			{
				id: "recycling-text-0",
				type: "text",
				data: {
					text: "Once materials do enter formal channels, this fragmentation becomes visible in collection performance across Europe. Norway leads with 25.9 kg collected per inhabitant, followed by Austria (15.8 kg) and France (15.2 kg). The composition of collected waste also differs significantly by region: in Poland (5.9 kg out of 14.6 kg) and Romania (5.5 kg out of 8.6 kg), large appliances account for the majority of recovered weight, while more mature systems such as Switzerland show a more balanced split between large (4.2 kg) and small appliances (5.1 kg). Meanwhile, structural gaps in collection infrastructure remain visible in countries such as Portugal (4.4 kg) and North Macedonia (3.4 kg), underscoring uneven system maturity across the region.",
				},
			},
			{
				type: "custom",
				id: "recycling-collection-weee",
				chartLabel: "Chart 1.13",
				data: {
					component: CollectionOfWEEEByEUMemberStates,
					props: {
						data: CollectionOfWEEEByEUMemberStatesData,
					},
				},
				marginalia: createChartMarginalia("WEEE forum", "recycling-collection-weee", "applia-home-appliance-monitor-2025_collected-waste-electrical-and-electronic-equipment.png", { label: "CHART 1.13" }),
			},
			{
				id: "recycling-text-1",
				type: "text",
				data: {
					text: "Aggregated appliance waste captured across Europe has maintained a steady <strong>upward trajectory</strong>. Total WEEE flows expanded to 4.9 million tonnes (a 4.3% increase over 2020). Downstream processing aligns tightly with this growth: out of the 4.9 million tonnes collected, processing plants routed 4.8 million tonnes directly into audited treatment facilities, ensuring localised volume surges do not bottleneck the infrastructure.",
				},
			},
			{
				type: "responsive-image",
				id: "recycling-weee-non-compliant-flows",
				chartLabel: "Chart 1.14",
				data: {
					desktopImageUrl: WeeeCollectedAndOtherNonCompliantFlowsDesktop,
					mobileImageUrl: WeeeCollectedAndOtherNonCompliantFlowsMobile,
					desktopClassName: "w-full lg:max-w-[90%]",
					mobileClassName: "max-w-lg",
					title: "WEEE collected and other-non-compliant flows",
					subtitle: "EU27+4 countries, in 2022",
				},
				marginalia: createChartMarginalia("Iattoni, G. et al. (2025) <a href='https://www.scycle.info/wp-content/uploads/2025/10/FutuRaM_CRM-FINAL.pdf' target='_blank' rel='noreferrer' class='text-primary hover:text-primary-hover hover:underline'>2050 Critical Raw Materials Outlook for Waste Electrical and Electronic Equipment in the European Union, United Kingdom, Switzerland, Iceland and Norway</a>. Bonn: United Nations Institute for Training and Research (UNITAR), Technische Universität Berlin, WEEE Forum, ecosystem.", "recycling-weee-non-compliant-flows", "applia-home-appliance-monitor-2025_weee-collected-and-other-non-compliant-flows.png", { label: "CHART 1.14" })
			},
			{
				id: "recycling-weee-flow-text-chart",
				type: "text-chart",
				chartLabel: "Chart 1.15",
				data: {
					text: [
						"Advanced treatment centers focus strictly on maximising resource extraction while minimising disposal waste. From total treated volume, operations successfully salvaged 4.4 million tonnes of aggregate resources. This culminated in <strong>4.0 million tonnes of fully reused and recycled raw materials</strong> reintroduced into manufacturing, sharply reducing the industry's reliance on primary resources.",
					],
					chartPosition: "right",
					textVerticalAlign: "center",
					component: WeeeFlowInTheHomeApplianceSector,
					props: {
						lineChartData: WeeeFlowInTheHomeApplianceSectorLineChartData,
					},
				},
				marginalia: createChartMarginalia("dss+", "recycling-weee-flow-text-chart", "applia-home-appliance-monitor-2025_weee-flows-in-the-home-appliance-sector.png", { label: "CHART 1.15" }),
			},
			{
				id: "recycling-materials-recovered",
				type: "text-image",
				data: {
					type: "image-right",
					imageUrl: MaterialsRecoveredFromWasteImg,
					imageAlt: "Materials recovered from waste",
					imageSize: "normal",
					roundedImage: false,
					text: [
						"Resource recovery relies on two parallel operational channels: regulated industrial processing systems and audited complementary trade flows. Formal industry channels provide the bulk of the volume, delivering <strong>2.7 million tonnes of total resource weight</strong> (2.6 Mt material recovery and 0.12 Mt energy recovery). Parallel complementary flows capture an extra 1 million tonnes (0.94 Mt material and 0.035 Mt energy recovery), proving that <strong>multi-channel tracking</strong> is vital to prevent materials from escaping the loop.", "A major circular success metric lies in reclaiming complex polymers from shredded electronics. Recycled plastic streams extracted from WEEE consist primarily of polypropylene (49.5%), polyethylene (30.3%), and high-impact polystyrene (18.1%). Rather than being downcycled, these high-purity polymers are directed to demanding manufacturing sectors. The <strong>automotive sector absorbs the largest single share</strong> (33.1%) , followed by exports and compounders (18.4%), construction (9.8%), durable goods (9.0%), and direct reinvestment into new electronics (6.3%).",
					],
				},
				marginalia: createChartMarginalia("dss+", "recycling-materials-recovered", "applia-home-appliance-monitor-2025_materials-recovered-from-waste.png", { infoBox: { title: "Info", body: "APPLiA is one of the founders of the I4R platform. The I4R platform, which was launched in 2018, is a user-friendly communication tool that aims to enhance recycling in the electrical and electronic sector. Its purpose is to reduce the compliance costs for both EEE manufacturers and WEEE recyclers by facilitating the exchange of information between them. For more, visit i4r-platform.eu" } , label: "CHART 1.16" })
			},
			{
				type: "responsive-image",
				id: "recycling-routes-of-recycled-plastic",
				chartLabel: "Chart 1.17",
				data: {
					desktopImageUrl: RoutesRecycledPlasticDesktop,
					mobileImageUrl: RoutesRecycledPlasticMobile,
					desktopClassName: "w-full",
					mobileClassName: "max-w-lg",
					title: "Routes of recycled plastics from WEEE"
				},
				marginalia: createChartMarginalia("dss+", "recycling-routes-of-recycled-plastic", "applia-home-appliance-monitor-2025_routes-of-recycled-plastics.png", { label: "CHART 1.17" })
			},
		],
	},
};
